import { render, staticRenderFns } from "./IdleMonitor.vue?vue&type=template&id=97cc799c&"
import script from "./IdleMonitor.vue?vue&type=script&lang=ts&"
export * from "./IdleMonitor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports